import { fromJS } from 'immutable';

import {
	CompanyAction,
	CompanyActionTypes as actionTypes
} from './companyTypes';

const initialState = fromJS({
	companies: {
		data: [],
		loading: false,
		error: null
	},
	createCompanies: {
		loading: false,
		error: null,
		data: null
	},
	updateCompanies: {
		loading: false,
		error: null,
		data: null
	},
	searchCompanies: {
		loading: false,
		data: [],
		error: null
	},
	hubspotCompanyId: {
		loading: false,
		data: null,
		error: null
	}
});

export default (state = initialState, action: CompanyAction) => {
	switch (action.type) {
		case actionTypes.USER_GET_COMPANIES_REQUEST:
			return state
				.setIn(['companies', 'loading'], true)
				.setIn(['companies', 'error'], null);

		case actionTypes.USER_GET_COMPANIES_SUCCESS:
			return state
				.setIn(['companies', 'loading'], false)
				.setIn(['companies', 'data'], action.payload);

		case actionTypes.USER_GET_COMPANIES_FAILURE:
			return state
				.setIn(['companies', 'loading'], false)
				.setIn(['companies', 'error'], action.payload);

		case actionTypes.CREATE_COMPANY_REQUEST:
			return state
				.setIn(['createCompanies', 'loading'], true)
				.setIn(['createCompanies', 'error'], null);

		case actionTypes.CREATE_COMPANY_SUCCESS:
			return state
				.setIn(['createCompanies', 'loading'], false)
				.setIn(['createCompanies', 'data'], action.payload);

		case actionTypes.CREATE_COMPANY_FAILURE:
			return state
				.setIn(['createCompanies', 'loading'], false)
				.setIn(['createCompanies', 'error'], action.payload)
				.setIn(['createCompanies', 'data'], null);
		case actionTypes.UPDATE_COMPANY_REQUEST:
			return state
				.setIn(['updateCompanies', 'loading'], true)
				.setIn(['updateCompanies', 'error'], null);
		case actionTypes.UPDATE_COMPANY_SUCCESS:
			return state
				.setIn(['updateCompanies', 'loading'], false)
				.setIn(['updateCompanies', 'data'], action.payload);
		case actionTypes.UPDATE_COMPANY_FAILURE:
			return state
				.setIn(['updateCompanies', 'loading'], false)
				.setIn(['updateCompanies', 'error'], action.payload);
		case actionTypes.CLEAR_COMPANY_ERRORS:
			return state
				.setIn(['createCompanies', 'error'], null)
				.setIn(['createCompanies', 'data'], null)
				.setIn(['updateCompanies', 'error'], null)
				.setIn(['updateCompanies', 'data'], null);
		case actionTypes.SEARCH_HUBSPOT_COMPANY_REQUEST:
			return state
				.setIn(['searchCompanies', 'loading'], true)
				.setIn(['searchCompanies', 'error'], null)
				.setIn(['searchCompanies', 'data'], []);

		case actionTypes.SEARCH_HUBSPOT_COMPANY_SUCCESS:
			return state
				.setIn(['searchCompanies', 'loading'], false)
				.setIn(['searchCompanies', 'data'], action.payload);

		case actionTypes.SEARCH_HUBSPOT_COMPANY_FAILURE:
			return state
				.setIn(['searchCompanies', 'loading'], false)
				.setIn(['searchCompanies', 'error'], action.payload);

		case actionTypes.GET_COMPANY_HS_ID_REQUEST:
			return state
				.setIn(['hubspotCompanyId', 'loading'], true)
				.setIn(['hubspotCompanyId', 'error'], null)
				.setIn(['hubspotCompanyId', 'data'], null);

		case actionTypes.GET_COMPANY_HS_ID_SUCCESS:
			return state
				.setIn(['hubspotCompanyId', 'loading'], false)
				.setIn(['hubspotCompanyId', 'data'], action.payload);

		case actionTypes.GET_COMPANY_HS_ID_FAILURE:
			return state
				.setIn(['hubspotCompanyId', 'loading'], false)
				.setIn(['hubspotCompanyId', 'error'], action.payload);
		default:
			return state;
	}
};
